import { Navigate, createFileRoute, useParams } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/')({
  component: IndexRedirect,
});

function IndexRedirect() {
  const { fleetId, endCustomerUnitId } = useParams({
    strict: false,
  });

  return (
    <Navigate
      to="/fleets/$fleetId/units/$endCustomerUnitId/specifications"
      params={{
        fleetId: fleetId!,
        endCustomerUnitId: endCustomerUnitId!,
      }}
      replace
    />
  );
}
